import { useEffect, useState } from 'react';
import {
  searchCarsFromCatalog,
  searchCruisesFromCatalog,
  searchHotelsFromCatalog,
  searchPackagesFromCatalog,
} from '../utils/catalogSearch';
import { generateFlightResults } from '../utils/searchResults';

/**
 * Dummy-only travel search — no live APIs.
 */
export function useTravelSearch(type, params, { enabled = true } = {}) {
  const [loading, setLoading] = useState(enabled);
  const [results, setResults] = useState([]);
  const [catalogInfo, setCatalogInfo] = useState(null);

  const paramKey = JSON.stringify(params);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      setResults([]);
      setCatalogInfo(null);
      return undefined;
    }

    let cancelled = false;
    const timer = window.setTimeout(() => {
      let data = [];
      let info = null;

      if (type === 'flights') {
        data = generateFlightResults(params);
        info = `${data.length} sample flights for this route`;
      } else if (type === 'hotels') {
        data = searchHotelsFromCatalog(params, 80);
        info = `${data.length} sample hotels`;
      } else if (type === 'cars') {
        data = searchCarsFromCatalog(params, 80);
        info = `${data.length} sample rentals`;
      } else if (type === 'packages') {
        data = searchPackagesFromCatalog(params, 80);
        info = `${data.length} sample packages`;
      } else if (type === 'cruises') {
        data = searchCruisesFromCatalog(params, 80);
        info = `${data.length} sample cruises`;
      }

      if (!cancelled) {
        setResults(data);
        setCatalogInfo(info);
        setLoading(false);
      }
    }, 450);

    setLoading(true);
    setCatalogInfo(null);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [type, paramKey, enabled]);

  return {
    loading,
    results,
    source: 'demo',
    error: null,
    catalogInfo,
    isLive: false,
  };
}
